import { jwtDecode, JwtPayload } from "jwt-decode";

export const decodeToken = (token: string) => {
  try {
    return jwtDecode<JwtPayload>(token);
  } catch (error) {
    console.error('Error al decodificar el token:', error);
    return null;
  }
};


